import './Register.scss'
import { FaFacebook, FaTwitter } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import React from 'react';
import { useFormik } from 'formik'
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import { toast } from 'react-toastify'
// import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

const GoogleLoginButton = () => {
    const handleLogin = () => {
        window.location.href = "http://localhost:3010/auth/google";
    };

    return <FaGoogle onClick={handleLogin} className="icon ms-4 fs-3" />;
};

const AdminRegister = () => {
    const navigate = useNavigate();
   
    const formik = useFormik({
        initialValues: {
            admin_fName: "",
            admin_lName: "",
            admin_email: "",
            admin_moNo: "",
            admin_pass: "",
            admin_conf_pass: "",
            role: "",
            admin_img: null,
        },

        validate: (values) => {
            const errors = {};

            if (!values.admin_fName) {
                errors.admin_fName = "Please Enter Valid User Name";
            } else if (!/^[a-zA-Z ]+$/.test(values.admin_fName)) {
                errors.admin_fName = "Name should only contain letters and Spaces";
            }

            if (!values.admin_lName) {
                errors.admin_lName = "Please Enter Valid User Name";
            } else if (!/^[a-zA-Z ]+$/.test(values.admin_lName)) {
                errors.admin_lName = "Name should only contain letters and Spaces";
            }

            if (values.admin_email) {
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.admin_email)) {
                    errors.admin_email = "Please Enter Valid email Address";
                }
            } else {
                errors.admin_email = "Invalid email address";
            }

            if (!values.admin_moNo.trim()) {
                errors.admin_moNo = "Please enter a valid mobile number.";
            } else if (!/^[6-9]\d{9}$/.test(values.admin_moNo)) {
                errors.admin_moNo = "Mobile number must start with 6-9 and contain exactly 10 digits.";
            } else if (values.admin_moNo.length !== 10) {
                errors.admin_moNo = "Mobile number must be exactly 10 digits.";
            } else if (/\D/.test(values.admin_moNo)) {
                errors.admin_moNo = "Only numbers are allowed.";
            }


            if (!values.admin_pass) {
                errors.admin_pass = "Please Enter Password";
            } else if (values.admin_pass.length < 8) {
                errors.admin_pass = "Password should be at least 8 characters long";
            } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(values.admin_pass)) {
                errors.admin_pass = "Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*)";
            }


            if (!values.admin_conf_pass) {
                errors.admin_conf_pass = "Please confirm your password";
            } else if (values.admin_conf_pass !== values.admin_pass) {
                errors.admin_conf_pass = "Passwords do not match";
            }
            if (!values.admin_img) {
                errors.admin_img = "Please upload an image";
            }

            // Role validation
            if (!values.role) {
                errors.role = "Please select a role";
            }

            return errors;
        },

        onSubmit: async (values) => {
            console.log(values);
            const formData = new FormData();

            // Ensure admin_img is a valid File
            if (values.admin_img && values.admin_img instanceof File) {
                const file = values.admin_img;
                const fileExtension = file.name.split('.').pop(); // Extract extension
                const randomFileName = `${Date.now()}_${Math.random().toString(36).substring(2, 10)}.${fileExtension}`;

                // Create a new File instance
                const modifiedFile = new File([file.slice(0, file.size)], randomFileName, { type: file.type });

                console.log("Modified File Name:", modifiedFile.name);

                // Alternative Method: Use set() instead of append()
                formData.set("admin_img", modifiedFile);
            } else {
                console.error("admin_img is not a valid File object:", values.admin_img);
            }

            // Append other form values
            const formEntries = {
                admin_fName: values.admin_fName || "",
                admin_lName: values.admin_lName || "",
                admin_email: values.admin_email || "",
                admin_moNo: values.admin_moNo || "",
                admin_pass: values.admin_pass || "",
                admin_conf_pass: values.admin_conf_pass || "",
                role: values.role || "",
            };

            // Alternative Method: Use `forEach` to append values
            Object.entries(formEntries).forEach(([key, value]) => {
                formData.append(key, value);
            });

            // Correct way to debug FormData
            console.log("FormData Debugging:", formData);
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }

            // ✅ Send FormData via Axios
            axios.post('https://ridehire-backend-2.onrender.com/admin/register', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(response => {
                console.log("Response:", response);
                if (response.data.token) {
                    localStorage.setItem("tokenAdmin", response.data.token);
                    console.log('Token stored successfully!');
                }
                navigate('/admin/adminLogin');
                toast.success("Registration Successful");
            }).catch(error => {
                console.error('Error:', error);
                alert(error.response ? error.response.data.message : "Registration Failed. Please try again.");
                toast.error("Registration Failed");
            });

        }


    })


    return (
        <>
            <div className="conatiner banner mt-5">
                <div className="row signin m-0">
                    <div className='text-white mt-5 ps-5'>
                        <a href='/admin/home' className='text-white text-decoration-none'><h6 className=''>Home &nbsp; / &nbsp; Register</h6></a>
                        <h3 className='text-white'>admin Register</h3>
                    </div>
                </div>

                <div className="container register-form mb-5">
                    <div className="row justify-content-center ">
                        <div className="box row p-3 mt-5 border border-secondary-subtle rounded">
                            <div className='d-flex justify-content-center'>
                                <h2>Register Here</h2>
                            </div>

                            <form method='post' onSubmit={formik.handleSubmit}>
                                <div className="row mt-4 my-4">
                                    <div className="col-md-6 col-12 ">
                                        <label htmlFor="">First Name </label>
                                        <input type="text" name='admin_fName' value={formik.values.admin_fName} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control mt-2 shadow-none' placeholder='First Name' />
                                        {formik.touched.admin_fName && formik.errors.admin_fName ? (
                                            <p className="text-danger">{formik.errors.admin_fName}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="">Last Name </label>
                                        <input type="text" name='admin_lName' value={formik.values.admin_lName} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Last Name' />
                                        {formik.touched.admin_lName && formik.errors.admin_lName ? (
                                            <p className="text-danger">{formik.errors.admin_lName}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Email </label>
                                        <input type="email" name='admin_email' value={formik.values.admin_email} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Enter Email' />
                                        {formik.touched.admin_email && formik.errors.admin_email ? (
                                            <p className="text-danger">{formik.errors.admin_email}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Mobile No </label>
                                        <input type="text" name='admin_moNo' value={formik.values.admin_moNo} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Mobile Number' />
                                        {formik.touched.admin_moNo && formik.errors.admin_moNo ? (
                                            <p className="text-danger">{formik.errors.admin_moNo}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Password </label>
                                        <input type="password" name='admin_pass' value={formik.values.admin_pass} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 form-control shadow-none mt-2' placeholder='Password' />
                                        {formik.touched.admin_pass && formik.errors.admin_pass ? (
                                            <p className="text-danger">{formik.errors.admin_pass}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label>Confirm Password</label>
                                        <input type="password" name="admin_conf_pass" value={formik.values.admin_conf_pass} onChange={formik.handleChange} onBlur={formik.handleBlur} className="w-100 form-control shadow-none mt-2" placeholder="Re-Enter Password" />
                                        {formik.touched.admin_conf_pass && formik.errors.admin_conf_pass ? (
                                            <p className="text-danger">{formik.errors.admin_conf_pass}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Image </label>
                                        {/* <input type="file" name='admin_img' value={formik.values.admin_img} onChange={formik.handleChange}  /> */}
                                        <input
                                            type="file"
                                            name="admin_img"
                                            onChange={(event) => {
                                                formik.setFieldValue("admin_img", event.currentTarget.files[0]); // Set file properly
                                            }} onBlur={formik.handleBlur}
                                            className="w-100 form-control shadow-none mt-2"

                                        />

                                        {formik.touched.admin_img && formik.errors.admin_img ? (
                                            <p className="text-danger">{formik.errors.admin_img}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 col-12 mt-3">
                                        <label htmlFor="">Role </label>
                                        <select id="role" name="role" value={formik.values.role} onChange={formik.handleChange} onBlur={formik.handleBlur} className='w-100 p-2 mt-2 form-control shadow-none' >
                                            <option value="">Select Role</option>
                                            <option value="admin">Admin</option>
                                            <option value="admin">admin</option>
                                        </select>
                                        {formik.touched.role && formik.errors.role ? (
                                            <p className="text-danger">{formik.errors.role}</p>
                                        ) : null}
                                    </div>

                                    <div className="remember-forgot d-flex align-items-center mt-4">
                                        <div className="remember-me">
                                            <input className="form-check-input" type="checkbox" value="" id="invalidCheck" required />
                                            <label className="form-check-label ms-3" htmlFor="invalidCheck">
                                                Agree to terms and conditions
                                            </label>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-center'>
                                        <button type="submit" className='submit-btn w-25 mt-4 text-white rounded py-2'>Submit</button>
                                    </div>

                                    <div className="divider d-flex align-items-center my-4 py-0">
                                        <span className='fs-6 px-4'>Or Continue With</span>
                                    </div>

                                    <div className="form-social d-inline-flex justify-content-center">
                                        <div>
                                            <FaFacebook className="icon fs-3" />

                                            <GoogleLoginButton />

                                            
                                            <FaTwitter className="icon ms-4 fs-3" />
                                        </div>
                                    </div>
                                    <div className="signup-link d-inline-flex justify-content-center mt-3">
                                        <p>Already have an account? <a href="/admin/login" className='font-weight-bold text-black text-decoration-none'>Sign In</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default AdminRegister;